import {
  CampaignCategory,
  ReviewSection,
  ReviewTarget,
  FormatVersion,
  CampaignCostHandlingMethod,
} from '~/generated/graphql'
import { CampaignInputComponent, CampaignInputComponentProps } from './CampaignInputComponent'
import { Controller, useFormContext } from 'react-hook-form'
import { Stack, TextField, Typography } from '@mui/material'
import { URL_VALIDATION_REGEXP } from '~/lib/constants'
import { z } from 'zod'
import { categoryField } from './type'
import { ValidationErrorMessage } from '~/components/common/ValidationErrorMessage'
import { getUrlTitle } from '~/lib/feature/getCampaignTitle'

export const sponsorServiceUrlSchemaFields = {
  url: z
    .string({
      required_error: '必須項目です',
    })
    .regex(
      URL_VALIDATION_REGEXP,
      'URLが正しくありません。URLの先頭が https:// または http://になっているか確認してください。',
    )
    .min(1)
    .max(1024, 'URLは1024文字以内で入力してください。'),
  costHandlingMethod: z.nativeEnum(CampaignCostHandlingMethod),
  ...categoryField,
}
export const sponsorServiceUrlSchema = z.object(sponsorServiceUrlSchemaFields)

type Props = CampaignInputComponentProps

export const SponsorServiceUrl = ({ description, tooltip }: Props) => {
  const { control, watch, getValues } = useFormContext<z.infer<typeof sponsorServiceUrlSchema>>()
  const category = watch('category')
  const costHandlingMethod = getValues('costHandlingMethod')
  return (
    <CampaignInputComponent
      title={getUrlTitle(costHandlingMethod, category)}
      required={true}
      description={description}
      tooltip={tooltip}
      review={{
        section: ReviewSection.Campaign,
        targets: [ReviewTarget.Url],
      }}
      compatibleFormatVersions={[FormatVersion.V4Campaign]}
    >
      <Stack gap={2}>
        <Typography variant="body2" pb={1}>
          {category === CampaignCategory.Service
            ? '実際に体験するサービスの内容が確認できるサイトや予約ページなどのURLをご入力ください。'
            : 'インフルエンサーが実際に購入するために販売ページのURLをご入力ください。'}
        </Typography>
      </Stack>
      <Controller
        name="url"
        render={({ field: { ref, ...field }, fieldState }) => (
          <TextField
            fullWidth
            placeholder="https://marketing.toridori.me"
            error={!!fieldState.error}
            helperText={<ValidationErrorMessage error={fieldState.error?.message} />}
            inputRef={ref}
            {...field}
          />
        )}
        control={control}
      />
    </CampaignInputComponent>
  )
}
